export const defaultErr = "Заполните поле";
export const verifyErr = "Пароли не совпадают";
